
(function () {
  'use strict';

  function camelCaseToUnderscores() {
      return function (value) {
        var formatted = '';
        for (var i = 0; i < value.length; i++) {
          var charVal = value.substring(i, i + 1);
          if (charVal.toUpperCase() === charVal) {
            if (formatted.length > 0) {
              formatted = formatted + '_';
            }
            formatted = formatted + charVal.toLowerCase();
          } else {
            formatted = formatted + charVal;
          }
        }
  
        return formatted;
      };
  }

  angular.module('ecap.common').filter('camelCaseToUnderscores', camelCaseToUnderscores);
})();